 
export default function Avatar({ initials, color, size = 40, showOnline = false }) {
  return (
    <div style={{ position: "relative", flexShrink: 0, width: size, height: size }}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          background: color || "#6B7280",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: Math.round(size * 0.35),
          fontWeight: 600,
          color: "#fff",
          userSelect: "none",
          letterSpacing: 0.5,
        }}
      >
        {initials}
      </div>
 
      {showOnline && (
        <span
          style={{
            position: "absolute",
            bottom: 1,
            right: 1,
            width: 10,
            height: 10,
            borderRadius: "50%",
            background: "#22c55e",
            border: "2px solid #fff",
          }}
        />
      )}
    </div>
  );
}